
//! Import the necessary modules
import { API_URI } from "../../constants/consts";
import { defineCancelApiObject } from "./configs/axiosUtils";


//* Axios
import { api } from "./configs/axiosConfigs";

export const AuthAPI = {
  changePasswordFirstLogin: async function (
    token: string,
    password: string,
    cancel = false
  ) {
    return api
      .request({
        url: `${API_URI}/admin/private/users/change-password`,
        method: "POST",
        headers: {
          Authorization: token,
        },
        data: { password: password },
        // signal: cancel
        //   ? cancelApiObject[this.get.name].handleRequestCancellation().signal
        //   : undefined,
      })
      .then((response) => {
        return response.data;
      });
  },

  authorize: async function (email: string, password: string, cancel = false) {
    return api
      .request({
        url: `${API_URI}/admin/public/login`,
        method: "POST",
        data: { email, password },
        // signal: cancel
        //   ? cancelApiObject[this.get.name].handleRequestCancellation().signal
        //   : undefined,
      })
      .then((response) => {
        return response.data;
      })
      .catch((e) => {
        console.log(e);
        return e;
      });
  },

  me: async function (token: string, cancel = false) {
    return api.request({
      url: `${API_URI}/admin/private/users/itself`,
      method: "GET",
      headers: {
        Authorization: "Bearer " + token,
      },
      // signal: cancel
      //   ? cancelApiObject[this.getAll.name].handleRequestCancellation().signal
      //   : undefined,
    });
    // .then((response) => {
    //   const payload = response.data;
    //   return payload.data;
    // }).catch((e)=>{
    //   console.log(e)
    //   return e;
    // });;
  },

  // 1. Solicitar código de redefinição
  requestPasswordReset: async function (
    email: string,
    cancel: boolean = false
  ): Promise<any> {
    return api
      .request({
        url: `${API_URI}/admin/public/forgot-password/request`,
        method: "POST",
        data: { email },
        // signal: cancel
        //   ? cancelApiObject[this.requestPasswordReset.name].handleRequestCancellation().signal
        //   : undefined,
      })
      .then((response) => response.data)
      .catch((e) => {
        console.error(e);
        throw e;
      });
  },

  // 2. Verificar código de redefinição
  verifyResetCode: async function (
    email: string,
    code: string,
    cancel: boolean = false
  ): Promise<any> {
    return api
      .request({
        url: `${API_URI}/admin/public/forgot-password/verify`,
        method: "POST",
        data: { email, code },
        // signal: cancel
        //   ? cancelApiObject[this.verifyResetCode.name].handleRequestCancellation().signal
        //   : undefined,
      })
      .then((response) => response.data)
      .catch((e) => {
        console.error(e);
        throw e;
      });
  },

  // 3. Redefinir senha
  resetPassword: async function (
    email: string,
    password: string,
    passwordConfirmation: string,
    cancel: boolean = false
  ): Promise<any> {
    return api
      .request({
        url: `${API_URI}/admin/public/forgot-password/reset`,
        method: "POST",
        data: {
          email,
          password,
          password_confirmation: passwordConfirmation,
        },
        // signal: cancel
        //   ? cancelApiObject[this.resetPassword.name].handleRequestCancellation().signal
        //   : undefined,
      })
      .then((response) => response.data)
      .catch((e) => {
        console.error(e);
        throw e;
      });
  },
};
// defining the cancel API object for ProductAPI
// eslint-disable-next-line @typescript-eslint/no-unused-vars
const cancelApiObject = defineCancelApiObject(AuthAPI);